import service from '@/service'

/**
 * @description 物流对接列表查询
 */
export function getList(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/kelipu/getList',
    method: 'post',
    data
  })
}

/**
 * @description 再次对接
 */
export function manualDock(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/kelipu/manualDock',
    method: 'post',
    data
  })
}

/**
 * @description 标记完成
 */
export function markDone(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/kelipu/markCompleted',
    method: 'post',
    data
  })
}

/**
 * @description 根据出库单号获取出库单商品详情
 */
export function detailListByOrderOutCode(params) {
  return service['api-scm']({
    url: '/public/warehouseOrderOut/detailListByOrderOutCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
